const ParserStatus = {
  AFTER_CR: -1,
  FIELD_START: 0,
  FIELD: 1,
  VALUE_START: 2,
  VALUE: 3,
};

export default ParserStatus;
